import { makeStyles } from '@material-ui/core'

const useThankYouStyles = makeStyles((theme) => {
    const mobileBreakpoint = theme.breakpoints.down('sm')
    const maxImgHeight = 'calc(48vh - 50px)'
    return {
        thankYouWrapper: {
            display: 'flex',
            maxWidth: '1441px',
            minHeight: 'calc(100vh - 208px)',
            padding: '24px 88px',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 0,
            marginLeft: 'auto',
            marginRight: 'auto',
            [mobileBreakpoint]: {
                display: 'block',
                width: '100%',
                height: 'auto',
                position: 'relative'
            }
        },
        wrapper: {
            marginTop: theme.spacing(8),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        imageColumn: {
            display: 'flex',
            position: 'fixed',
            flexDirection: 'column',
            maxHeight: '900px',
            [mobileBreakpoint]: {
                display: 'none'
            }
        },
        thankYouBox: {
            display: 'flex',
            width: '611px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '32px',
            [mobileBreakpoint]: {
                marginBottom: '25px'
            }
        },
        dottedLine: {
            width: 0,
            height: '27px',
            marginLeft: '15px',
            borderLeft: '2px dotted #9E9E9E'
        },
        applicationBox: {
            zIndex: 1,
            display: 'flex',
            width: '449px',
            padding: '40px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            borderRadius: '4px',
            background: 'var(--neutrals-grey-00, #FFF)',
            boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.15), 0px 1px 10px rgba(0, 0, 0, 0.15), 0px 2px 4px rgba(0, 0, 0, 0.15)',
            maxHeight: '900px',
            minWidth: '400px',
            [mobileBreakpoint]: {
                width: '100%'
            }
        },
        bannerTitle: {
            alignSelf: 'stretch',
            margin: 0,
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '42px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '58px'
        },
        heading: {
            alignSelf: 'stretch',
            margin: 0,
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '34px'
        },
        additionalContent: {
            alignSelf: 'stretch',
            margin: 0,
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '22px'
        },
        learnMoreRow: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            margin: 0
        },
        learnMoreLink: {
            color: 'var(--primary-primary-500, #007DB8)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '22px',
            textDecoration: 'none',
            cursor: 'pointer'
        },

        arrowIcon: {
            width: '16px',
            height: '16px',
            color: 'var(--primary-primary-500, #007DB8)'
        },
        applicationContent: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '16px',
            alignSelf: 'stretch'
        },
        applicationStatusTitle: {
            margin: 0,
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '22px'
        },
        statusBullets: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch'
        },
        statusRow: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '14px'
        },
        statusIcon: {
            display: 'block',
            width: '32px',
            height: '32px'
        },
        statusText: {
            margin: 0,
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '22px'
        },

        trapezoidBg: {
            position: 'relative',
            // minHeight: '80vh',
            overflow: 'hidden',
            // zIndex: 1,
            '&::before': {
                content: '""',
                background: 'linear-gradient(234deg, #005C82 28.58%, #0B9EDB 99.46%)',
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                clipPath: 'polygon(95% 0, 100% 0, 100% 100%, 37.5% 100%)'
            }
        }
    }
})

export default useThankYouStyles
